import sqftConfig from "./sqftConfig";
import sqftImageManager from "./sqftImageManager";
import sqftShapeManager from "./sqftShapeManager";
import workspace from "../core/workspace";
import slabWorkspace from "../core/slab/slabWorkspace";
import store from "../../../../../store";
import {setIsRoomSwitcherVisible} from "../../../../../actions/sqftMenuFunctions";
import sqftSlabManager from "./sqftSlabManager";
import sqftShapeIntersectionsManager from "./sqftShapeIntersectionsManager";
import workspaceControllers from "./workspaceControllers";

export const enableRegularMode = () => {
  store.dispatch(setIsRoomSwitcherVisible(true));
  //sqftConfig.workspace.snapToGrid = true;
  slabWorkspace.disableSlabImages();
  slabWorkspace.deregisterEvents();
  sqftImageManager.hideSlabImages();
  sqftShapeManager.hideSeamShapes();
  sqftShapeManager.hideSlabShapes();

  sqftSlabManager.deleteShapeOffset();

  sqftImageManager.restoreTextBoxes();
  sqftImageManager.restoreImages();
  sqftShapeManager.restoreCorePieceShapes();
  sqftShapeManager.restoreShapeParts();

  slabWorkspace.slabAdditionalShapes.hideAdditionalShapes(); //this should go last
};

export const enableSlabMode = (shouldUpdatePlaceholderFeatureIds = false) => {
  store.dispatch(setIsRoomSwitcherVisible(false));
  sqftConfig.workspace.snapToGrid = false;
  sqftImageManager.restoreSlabImages();
  sqftShapeManager.checkForUpdateSlabPoints();
  sqftShapeManager.checkForUpdateSlabPosition();
  sqftShapeManager.restoreSeamShapes();
  sqftShapeManager.restoreSlabShapes();

  sqftSlabManager.reInitShapeOffset();

  slabWorkspace.slabAdditionalShapes.initWaterfallToolShapes(); // 1
  slabWorkspace.slabAdditionalShapes.initBacksplashAndEdgeShapes();
  slabWorkspace.slabAdditionalShapes.initMiteredToolShapes(); // 2
  slabWorkspace.slabAdditionalShapes.initUnderlaymentToolShapes(); // 2
  slabWorkspace.slabAdditionalShapes.initBumpoutShapes();
  slabWorkspace.slabAdditionalShapes.restoreBacksplashShapes();
  slabWorkspace.initLeftPart();

  sqftImageManager.hideImages();
  sqftImageManager.hideTextBoxes();
  sqftShapeManager.hideShapeParts();
  sqftShapeManager.hideCorePieceShapes();

  if (shouldUpdatePlaceholderFeatureIds) {
    window.setTimeout(() => { // first we need to enable slab mode to get slab mode coordinates for the shape
      sqftShapeIntersectionsManager.updateShapesIntersections();
      sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
      sqftShapeIntersectionsManager.updateShapesFeaturePlacedOnSlabImages();
      workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);
    }, 0)
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
};

export const createSlabModeWaterfallShapes = () => {
  slabWorkspace.slabAdditionalShapes.initWaterfallToolShapes(); // 1
  slabWorkspace.slabAdditionalShapes.initMiteredToolShapes(); // 2
  slabWorkspace.slabAdditionalShapes.hideAdditionalShapes(); //this should go last
}

export const clearRotateAngles = () => {
  sqftConfig.highlight.rotateAngle = false;
  const angleTooltip = document.getElementById("angle-tooltip");
  if (angleTooltip) {
    angleTooltip.style.display = "none";
  }

  workspace.getShapes().forEach((shape) => {
    if (Array.isArray(shape.rotateAngleParts) && shape.rotateAngleParts.length) {
      shape.deActivateRotateAngle();
    }
  });
}

export const getDimensionsDependingOnShapePositions = (workspace) => {
  const {minX, maxX, minY, maxY} = sqftShapeManager.getMinMaxWorkspacePoints(workspace, true);
  let maxCordX = Math.abs(minX) > Math.abs(maxX) ? Math.abs(minX) : Math.abs(maxX);
  let maxCordY = Math.abs(minY) > Math.abs(maxY) ? Math.abs(minY) : Math.abs(maxY);

  let imageWidth = maxCordX / sqftConfig.scale * Math.pow(sqftConfig.defaultScale, 2) + 500 / sqftConfig.scale * sqftConfig.defaultScale;
  let imageHeight = maxCordY / sqftConfig.scale * Math.pow(sqftConfig.defaultScale, 2) + 500 / sqftConfig.scale * sqftConfig.defaultScale;

  //todo re-wright this
  if (window.innerWidth < 1024) {
    imageWidth *= 3.75
    imageHeight *= 3.75
  }

  return [imageWidth, imageHeight]
}

export const getFontSizeFromContext = (ctx) => {
  const fontSizeMatch = ctx.font.match(/\d+/);
  return fontSizeMatch ? Number(fontSizeMatch[0]) : null;
}
